import { datumUsageNew, DatumVerticalUsageType, type DatumUsage } from "building-types/datums/datumUsageTypes";
import type { PrimaryEntityId } from "building-types/doc/primaryEntityId";
import type { FormulaDisabledDocEntityBase } from "building-types/entities/docEntityBase";
import type { Table } from "common/data/table";
import type { Mat3 } from "geom/mat3";
import type { LabelableEntityBase } from "../entities/labelTypes";
import type { ForeignEntityId } from "../handles/foreignEntityId";

export enum ComponentVerticalPlacementType {
  REMAPPING = "REMAPPING",
  REPLICATION = "REPLICATION",
}

export interface ComponentVerticalPlacementBase {
  readonly type: ComponentVerticalPlacementType;
}

export interface ComponentVerticalPlacementRemapping extends ComponentVerticalPlacementBase {
  readonly type: ComponentVerticalPlacementType.REMAPPING;
  readonly levelRemapping?: Table<ForeignEntityId<"LEVEL">>;
}

export interface ComponentVerticalPlacementReplication extends ComponentVerticalPlacementBase {
  readonly type: ComponentVerticalPlacementType.REPLICATION;
  readonly datumUsage?: DatumUsage<DatumVerticalUsageType.COMPONENT_PLACEMENT>;
}

export type ComponentVerticalPlacement = ComponentVerticalPlacementRemapping | ComponentVerticalPlacementReplication;

export interface ComponentInstance extends FormulaDisabledDocEntityBase<"COMPONENT_INSTANCE">, LabelableEntityBase {
  readonly id: PrimaryEntityId<"COMPONENT_INSTANCE">;
  readonly componentId: ForeignEntityId<"COMPONENT">;
  readonly verticalPlacement: ComponentVerticalPlacement;
  readonly matrix: Mat3;
  readonly mirrorX?: boolean;
  readonly mirrorY?: boolean;
  readonly mirrorCenterX?: number;
  readonly mirrorCenterY?: number;
}

export function createRemappingVerticalPlacement(levelRemapping: Table<string>): ComponentVerticalPlacement {
  return {
    type: ComponentVerticalPlacementType.REMAPPING,
    levelRemapping,
  };
}

export function createReplicationVerticalPlacement(datum?: string, offset?: number): ComponentVerticalPlacement {
  const datumUsage = datum ? datumUsageNew(DatumVerticalUsageType.COMPONENT_PLACEMENT, datum, offset) : undefined;

  return {
    type: ComponentVerticalPlacementType.REPLICATION,
    datumUsage,
  };
}
